var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentcolor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.207 10.793a1 1 0 0 1 .083 1.32l-.083.094-5 5a1 1 0 0 1-1.497-1.32l.083-.094 4.292-4.293-4.292-4.293a1 1 0 0 1-.083-1.32l.083-.094a1 1 0 0 1 1.32-.083l.094.083z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.5 11.5a1 1 0 0 1-.883.993l-.117.007H6a1 1 0 0 1-.117-1.993L6 10.5h10.5a1 1 0 0 1 1 1"
}))));
export { SvgArrowRight as ReactComponent };
export default __webpack_public_path__ + "assets/images/arrow-right.svg";